(function () {
  'use strict';

  const WGE_SRC_SESSION_KEY = 'wge_custom_sourcing_session_id_v1';
  const WGE_SRC_SUBMIT_TIMEOUT_MS = 14000;
  const WGE_SRC_MAX_TEXT_LENGTH = 1500;

  function getWgeSrcRoot() {
    return document.getElementById('wge-custom-sourcing-page');
  }

  function getWgeSrcSessionId() {
    try {
      const existing = sessionStorage.getItem(WGE_SRC_SESSION_KEY);

      if (existing && existing.length <= 120) {
        return existing;
      }

      const generated = 'wge-src-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem(WGE_SRC_SESSION_KEY, generated);

      return generated;
    } catch (error) {
      return 'wge-src-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }
  }

  function cleanWgeSrcValue(value, maxLength) {
    const limit = Number.isFinite(Number(maxLength)) ? Number(maxLength) : WGE_SRC_MAX_TEXT_LENGTH;

    return String(value || '')
      .replace(/\r/g, '\n')
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .join('\n')
      .slice(0, limit)
      .trim();
  }

  function getWgeSrcFieldLabel(field) {
    if (!field || !field.id) return 'This field';

    const label = document.querySelector('label[for="' + CSS.escape(field.id) + '"]');

    if (!label) return 'This field';

    return label.textContent.replace('*', '').trim() || 'This field';
  }

  function isWgeSrcEmailValid(value) {
    const email = cleanWgeSrcValue(value, 180);

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setWgeSrcStatus(type, title, message, ticketId) {
  const statusBox = document.getElementById('wge-src-transmission');

  if (!statusBox) return;

  statusBox.className = 'wge-src-transmission is-visible is-' + type;
  statusBox.textContent = '';

  if (type === 'loading') {
    const scanbar = document.createElement('div');
    scanbar.className = 'wge-src-scanbar';
    scanbar.setAttribute('aria-hidden', 'true');
    statusBox.appendChild(scanbar);
  }

  const heading = document.createElement('h3');
  heading.textContent = title;
  statusBox.appendChild(heading);

  const paragraph = document.createElement('p');
  paragraph.textContent = message;
  statusBox.appendChild(paragraph);

  if (ticketId) {
    const ticket = document.createElement('p');
    ticket.className = 'wge-src-reference-line';
    ticket.textContent = 'Reference ID: ' + ticketId;
    statusBox.appendChild(ticket);

    const note = document.createElement('p');
    note.className = 'wge-src-reference-note';
    note.textContent = 'Please keep this reference ID available for follow-up coordination.';
    statusBox.appendChild(note);
  }

  if (type === 'success') {
    const actions = document.createElement('div');
    actions.className = 'wge-src-transmission-actions';

    const discordLink = document.createElement('a');
    discordLink.className = 'wge-src-transmission-button wge-src-transmission-button-primary';
    discordLink.href = 'https://discord.gg/5wVDMwcRmf';
    discordLink.target = '_blank';
    discordLink.rel = 'noopener noreferrer';
    discordLink.textContent = 'Join Discord HQ';

    const collectionLink = document.createElement('a');
    collectionLink.className = 'wge-src-transmission-button';
    collectionLink.href = '/collections/dark-war-verified-assets';
    collectionLink.textContent = 'Browse Verified Accounts';

    actions.appendChild(discordLink);
    actions.appendChild(collectionLink);
    statusBox.appendChild(actions);
  }
}

  function clearWgeSrcStatus() {
    const statusBox = document.getElementById('wge-src-transmission');

    if (!statusBox) return;

    statusBox.className = 'wge-src-transmission';
    statusBox.textContent = '';
  }

  function markWgeSrcFieldError(field, hasError) {
    if (!field) return;

    field.classList.toggle('wge-src-input-error', Boolean(hasError));
  }

  function clearWgeSrcFieldErrors(form) {
    if (!form) return;

    form.querySelectorAll('.wge-src-input-error').forEach(function (field) {
      field.classList.remove('wge-src-input-error');
    });
  }

  function validateWgeSrcForm(form) {
    const errors = [];
    const requiredFields = Array.prototype.slice.call(form.querySelectorAll('[required]'));

    clearWgeSrcFieldErrors(form);

    requiredFields.forEach(function (field) {
      const fieldType = String(field.type || '').toLowerCase();

      if (fieldType === 'checkbox') {
        if (!field.checked) {
          markWgeSrcFieldError(field, true);
          errors.push('Please confirm the sourcing review and fee acknowledgement.');
        }

        return;
      }

      const value = cleanWgeSrcValue(field.value, WGE_SRC_MAX_TEXT_LENGTH);

      if (!value) {
        markWgeSrcFieldError(field, true);
        errors.push(getWgeSrcFieldLabel(field) + ' is required.');
      }
    });

    const emailField = form.querySelector('[name="primary_email"]');

    if (emailField && cleanWgeSrcValue(emailField.value, 180) && !isWgeSrcEmailValid(emailField.value)) {
      markWgeSrcFieldError(emailField, true);
      errors.push('Please enter a valid primary email address.');
    }

    return {
      ok: errors.length === 0,
      errors: errors
    };
  }

  function scrollToWgeSrcField(field) {
    if (!field || typeof field.scrollIntoView !== 'function') return;

    field.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    window.setTimeout(function () {
      try {
        field.focus({ preventScroll: true });
      } catch (error) {
        field.focus();
      }
    }, 320);
  }

  function buildWgeSrcPayload(form) {
    const data = new FormData(form);

    return {
      source: cleanWgeSrcValue(data.get('source'), 80) || 'custom_asset_sourcing_page',
      session_id: getWgeSrcSessionId(),
      page_url: cleanWgeSrcValue(data.get('page_url'), 260) || window.location.href,
      primary_email: cleanWgeSrcValue(data.get('primary_email'), 180),
      discord_id: cleanWgeSrcValue(data.get('discord_id'), 120),
      whatsapp_number: cleanWgeSrcValue(data.get('whatsapp_number'), 120),
      preferred_contact_method: cleanWgeSrcValue(data.get('preferred_contact_method'), 120),
      target_game: cleanWgeSrcValue(data.get('target_game'), 140),
      target_server_range: cleanWgeSrcValue(data.get('target_server_range'), 180),
      dominant_faction_priority: cleanWgeSrcValue(data.get('dominant_faction_priority'), 120),
      minimum_main_squad_cp: cleanWgeSrcValue(data.get('minimum_main_squad_cp'), 140),
      desired_vip_level: cleanWgeSrcValue(data.get('desired_vip_level'), 140),
      premium_cosmetic_requirements: cleanWgeSrcValue(data.get('premium_cosmetic_requirements'), 220),
      maximum_acquisition_budget: cleanWgeSrcValue(data.get('maximum_acquisition_budget'), 140),
      budget_flexibility: cleanWgeSrcValue(data.get('budget_flexibility'), 140),
      deal_timeline: cleanWgeSrcValue(data.get('deal_timeline'), 140),
      acquisition_readiness: cleanWgeSrcValue(data.get('acquisition_readiness'), 180),
      must_have_requirements: cleanWgeSrcValue(data.get('must_have_requirements'), 620),
      mission_notes: cleanWgeSrcValue(data.get('mission_notes'), 620),
      acknowledgement: data.get('acknowledgement') ? 'Accepted' : '',
      timestamp: Date.now()
    };
  }

  async function postWgeSrcPayload(endpoint, payload) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(function () {
      controller.abort();
    }, WGE_SRC_SUBMIT_TIMEOUT_MS);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      let data = null;

      try {
        data = await response.json();
      } catch (error) {
        data = null;
      }

      if (!response.ok) {
        const detail = data && data.detail ? String(data.detail) : 'WatchTower Ops could not accept this sourcing dossier.';
        throw new Error(detail);
      }

      if (!data || data.ok !== true) {
        throw new Error('WatchTower Ops returned an invalid sourcing response.');
      }

      return data;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function setWgeSrcSubmitState(button, isSubmitting) {
    if (!button) return;

    button.disabled = Boolean(isSubmitting);
    button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

    const label = button.querySelector('span');

    if (label) {
      label.textContent = isSubmitting ? 'Transmitting Dossier' : 'Submit Sourcing Dossier';
    }
  }

  function bindWgeSrcSmoothScroll() {
    document.querySelectorAll('[data-wge-scroll-target]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        const targetId = trigger.getAttribute('data-wge-scroll-target');
        const target = targetId ? document.getElementById(targetId) : null;

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }

  function bindWgeSrcFieldCleanup(form) {
    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('input', function () {
        markWgeSrcFieldError(field, false);
      });

      field.addEventListener('change', function () {
        markWgeSrcFieldError(field, false);
      });
    });
  }

  function bindWgeSrcForm() {
    const root = getWgeSrcRoot();
    const form = document.querySelector('[data-wge-src-form]');

    if (!root || !form) return;

    const submitButton = document.getElementById('wge-src-submit-button');
    const endpoint = form.getAttribute('data-wge-src-endpoint') || root.getAttribute('data-wge-src-endpoint');

    bindWgeSrcFieldCleanup(form);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (!endpoint) {
        setWgeSrcStatus(
          'error',
          'Sourcing Endpoint Missing',
          'This sourcing form is not connected to the WatchTower Ops backend yet.'
        );
        return;
      }

      const formData = new FormData(form);
      const honeypot = cleanWgeSrcValue(formData.get('company_website'), 200);

      if (honeypot) {
        setWgeSrcStatus(
          'success',
          'Dossier Received',
          'Your sourcing request has been received by WatchTower Ops.'
        );
        return;
      }

      const validation = validateWgeSrcForm(form);

      if (!validation.ok) {
        const firstInvalid = form.querySelector('.wge-src-input-error');

        setWgeSrcStatus(
          'error',
          'Dossier Requires Review',
          validation.errors[0] || 'Please complete the required fields before submitting.'
        );

        scrollToWgeSrcField(firstInvalid);
        return;
      }

      const payload = buildWgeSrcPayload(form);

      setWgeSrcSubmitState(submitButton, true);
      setWgeSrcStatus(
        'loading',
        'Transmitting Sourcing Dossier',
        'WatchTower Ops is sending your request into the private sourcing intake lane.'
      );

      try {
        const data = await postWgeSrcPayload(endpoint, payload);

        setWgeSrcStatus(
          'success',
          'Custom Account Sourcing Request Received',
          'Your custom account sourcing request has been received by WatchTower Ops. Our team will review your target profile, budget range, and preferred contact route before following up after the initial assessment.',
          data.ticket_id || ''
        );
      } catch (error) {
        const message = error && error.name === 'AbortError'
          ? 'The request timed out. Please try again in a moment.'
          : String(error && error.message ? error.message : 'Unable to submit this sourcing dossier right now.');

        setWgeSrcStatus(
          'error',
          'Transmission Failed',
          message
        );
      } finally {
        setWgeSrcSubmitState(submitButton, false);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    clearWgeSrcStatus();
    bindWgeSrcSmoothScroll();
    bindWgeSrcForm();
  });
})();